/**
 * Copyright 2020, GeoSolutions Sas.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

// eslint-disable-next-line no-restricted-imports
import { Button } from 'react-bootstrap';

import buttonWithDisabled from './enhancers/buttonWithDisabled';

export default buttonWithDisabled(Button);
